import React from 'react';

import { isSetupPending, subscribeSetupChanges } from './setupModel';

export const useWorkspaceSetupPending = (tenantId: string | null | undefined): boolean => {
  const [pending, setPending] = React.useState(false);

  React.useEffect(() => {
    const sync = () => {
      setPending(Boolean(tenantId) && isSetupPending(tenantId as string));
    };

    sync();
    return subscribeSetupChanges(sync);
  }, [tenantId]);

  return pending;
};
